var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53216 9.49236C6.24029 9.19846 5.76542 9.19681 5.47151 9.48869C5.1776 9.78057 5.17596 10.2554 5.46784 10.5493L6.53216 9.49236ZM8.92929 12.9705L8.39713 13.499L8.39713 13.499L8.92929 12.9705ZM15.5322 7.52849C15.824 7.23458 15.8224 6.75971 15.5285 6.46784C15.2346 6.17596 14.7597 6.1776 14.4678 6.47151L15.5322 7.52849ZM9.07071 12.9705L9.60287 13.499L9.60287 13.499L9.07071 12.9705ZM5.46784 10.5493L8.39713 13.499L9.46145 12.442L6.53216 9.49236L5.46784 10.5493ZM14.4678 6.47151L8.53855 12.442L9.60287 13.499L15.5322 7.52849L14.4678 6.47151ZM8.39713 13.499C8.72949 13.8337 9.27051 13.8337 9.60287 13.499L8.53855 12.442C8.7928 12.186 9.2072 12.186 9.46145 12.442L8.39713 13.499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dd085b1f06a6f00146154f7ca51758a5.svg";
export { ForwardRef as ReactComponent };